import NavBar from "./Components/NavBar";
import Hero from "./Components/Hero";
import MeetTeam from "./Components/MeetTeam";
import Accolades from "./Components/Accolades";
import Feedback from "./Components/Feedback";
import Hiring from "./Components/Hiring";
import Footer from "./Components/Footer";

function App() {
  return (
    <div className="">
      <NavBar />
      <Hero />
      <MeetTeam />
      <Accolades />
      <Feedback />
      <Hiring />
      <Footer />
    </div>
  );
}

export default App;
